import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const pubmedFormValidationSchema = () => {
  const fields: any = {
    pubmed_id: Yup.string().trim().required(requiredMessage).nullable(),
  };

  return Yup.object().shape(fields);
};
